import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import LazyHydration from 'components/LazyHydration';

const BlogArticles = dynamic(
  () => import('components/pages/OfferPages/BlogArticles')
);

const DynamicallyLoadedBlogArticles = ({
  gaEventCategory,
  relatedArticles,
}) => (
  <LazyHydration placeholderSize={{ height: 316 }}>
    <BlogArticles
      articles={relatedArticles.slice(3)}
      className="mt-6"
      gaEventCategory={gaEventCategory}
      headingClassName="mx-4 lg:mx-0"
    />
  </LazyHydration>
);

DynamicallyLoadedBlogArticles.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  relatedArticles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default DynamicallyLoadedBlogArticles;
